import Skeleton from 'components/LoadingSkeleton';

const OrderTotalSkeleton = () => {
  return (
    <>
      <div className="flex flex-row items-center gap-2 px-6 max-sm:max-h-[calc(100dvh-3rem)]">
        <Skeleton circle width={20} height={20} />
        <Skeleton circle width={20} height={20} />
        <Skeleton width={250} height={24} />
      </div>

      <div className="mt-ds-2xl h-auto px-6">
        <div className="typography-product-body-highlight rounded bg-color-bg-lightmode-primary p-4 dark:bg-color-bg-darkmode-primary">
          {/* Line items */}
          <div className="mb-2 flex justify-between">
            <Skeleton width={120} height={20} />
            <Skeleton width={60} height={20} />
          </div>

          {/* Date and Venue Info */}
          <div className="mb-2">
            <Skeleton width={220} height={16} className="mb-1" />
            <Skeleton width={180} height={16} />
          </div>

          {/* Platform Fee */}
          <div className="mb-4 flex items-center justify-between">
            <Skeleton width={120} height={18} />
            <Skeleton width={60} height={18} />
          </div>

          {/* Credit Card Fee */}
          <div className="mb-4 flex items-center justify-between">
            <Skeleton width={180} height={18} />
            <Skeleton width={60} height={18} />
          </div>

          {/* Intro Fee */}
          <div className="mb-4 flex items-center justify-between">
            <Skeleton width={140} height={18} />
            <Skeleton width={60} height={18} />
          </div>

          {/* Total */}
          <div className="typography-product-subheading flex justify-between">
            <Skeleton width={80} height={24} />
            <Skeleton width={80} height={24} />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderTotalSkeleton;
